// import bannersHeaderImage from '../assets/images/banners/header/arch.mju.ac.th_banner.png'
import { useEffect, useState } from "react";
// import './App.css';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
// import "jquery/dist/jquery.min.js";
// import "./assets/css/oldStyle.css";
// import "./assets/css/mainStyle.css";
import { NavTopMain } from "../components/navTop";
import {
    Banner,
    BannerPortrait,
    HeaderBanner,
    BannerDouble,
    PublicNews,
} from "../components/banners";
import BannerCarousel, { SubCarousel } from "../components/bannerCarousel";
import BoardActivities from "../components/board_activities";
import Activities from "../components/activities";
import PartnerBanners from "../components/partners";
import PageFooter from "../components/footer";
import YoutubeEmbed from "../components/video_youtube";
import MjuPrNews from "../components/mjuPR";

import AOS from "aos";
import "aos/dist/aos.css";
import Swal from "sweetalert2";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { ResearchBudgetCards } from "./ResearchBudget";

const showConsole = false;
const apiUrl = process.env.REACT_APP_API_URL;

export default function Home() {
    const [searchParams] = useSearchParams();
    const [navMenuItem, setNavMenuItem] = useState([]);
    // const [bannerHeader, setBannerHeader] = useState([]);

    function showAlert(icon, title, html = "") {
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            },
        });

        Toast.fire({
            icon: icon,
            title: title,
            html: html,
        });
    }

    async function fetchNavMenuItem() {
        await axios
            .get(`${apiUrl}nav/index.json`, {timeout: 2000})
            .then((res) => {
                setNavMenuItem(res.data);
            })
            .catch((error) => {
                // console.log(`%c${apiUrl}nav/index.json`, "color:yellow");
                console.error(`nav axios err: ${error}`);
                // window.open('/under_construction', '_self');
            });
    }

    useEffect(() => {
        console.clear();
        // const fetchData = async () => {
        //     try {
        //     } catch (e) {
        //         console.error("Error: ", e);
        //     }
        // };
        // fetchData();
        searchParams.get("alert") &&
            searchParams.get("msg") &&
            showAlert(
                searchParams.get("alert"),
                searchParams.get("msg"),
                searchParams.get("html")
            );

        fetchNavMenuItem();

        // setNavMenuItem(navMenuItem_bk)

        AOS.init();
        // eslint-disable-next-line
    }, [apiUrl]);
    showConsole && console.log("navMenuItem:", navMenuItem);
    return (
        <div className="" style={{ maxWidth: "1850px", margin: "0 auto" }}>
            {/* <h1>arch 2024 version presented by React.</h1> */}
            <div id="contentHolder" className="w-full mx-auto">
                <HeaderBanner />
                {navMenuItem && <NavTopMain navMenuItem={navMenuItem} />}
                <section id="mainContent">
                    <BannerPortrait />
                    <Banner />
                    <YoutubeEmbed />
                    <BannerCarousel />
                    <BannerDouble />
                    <SubCarousel name="carouselAct" />
                    <PublicNews />
                </section>
            </div>
            <BoardActivities />
            <Activities />
            <MjuPrNews />
            {/* <ResearchBudgetCards /> */}
            <PartnerBanners />
            {navMenuItem && <PageFooter navMenuItem={navMenuItem} />}
        </div>
    );
}
